import { render, staticRenderFns } from "./banUserMute.vue?vue&type=template&id=2933c5ef"
import script from "./banUserMute.vue?vue&type=script&lang=js"
export * from "./banUserMute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports